import { memo, type ReactNode } from 'react';

export type PrivateBoardSearchHeaderProps = {
  title: string;
  prefix?: ReactNode;
  rightAdornment?: ReactNode;
};

export const PrivateBoardSearchHeader = memo(({ title, prefix, rightAdornment }: PrivateBoardSearchHeaderProps) => {
  return (
    <div className="mb-2 flex h-6 content-between items-center">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {prefix}
        <h2 className="truncate font-bold ads:text-metadata text-12 text-gray-9 uppercase tracking-wider">{title}</h2>
      </div>
      {rightAdornment}
    </div>
  );
});

PrivateBoardSearchHeader.displayName = 'PrivateBoardSearch';
